<template>
  <LayoutAdmin>
    <h2 class="text-center text-primary mt-4">
      404 Not found | Oops! sepertinya anda memasukan url yang salah
    </h2>
  </LayoutAdmin>
</template>

<script>
import LayoutAdmin from "../components/Layout/Admin.vue";
export default {
  name: "NotFoundPage",
  components: { LayoutAdmin },
};
</script>

<style scoped>
</style>